<div #gmap class="map-container" [class.full-height]="fullHeight" [class.use-in-collection]="useInCollection"></div>
